// @ts-nocheck
import { React, Component, useState, useEffect, createContext, useMemo, useRef, useCallback } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Oval } from  'react-loader-spinner'
import { batch } from 'react-redux';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { Box, Button, ButtonGroup, Divider, Checkbox, Paper, Skeleton } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ru } from 'date-fns/locale';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getDashboardOnlineDevices } from '../../store/actions/device';

const _dataLabelDictionary = {
        'HASHRATE': 'Хешрейт (Th/s)',
        'DEVICE_COUNT': 'Кол-во устройств (шт.)',
        'COUNTER': 'Счетчики (P)',
        'GGU': 'ГПУ',
        'S': 'Модели S',
        'L': 'Модели L',
        'KS': 'Модели KS',
        'DEVICE_TYPE_COUNT': 'Кол-во по типу',
        'POOL_HASHRATE': 'Пулы'
    };

export default function OnlineDeviceSlicedDashboard({dataProps}) {
    const dispatch = useDispatch();

    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        today.setDate(today.getDate() - 1);
        today.setHours(0, 0, 0, 0);
        return today;
    });
    const [endDate, setEndDate] = useState(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        return tomorrow;
    });
    const [selectedDataType, setSelectedDataType] = useState([]);
    const [selectedTimeframe, setSelectedTimeframe] = useState('1h');
    const [isLoading, setIsLoading] = useState(false);
    const [isModesLoading, setIsModesLoading] = useState(false);
    const [transformedData, setTransformedData] = useState([]);
    const [columns, setColumns] = useState([]);
    
    const _fetch_modes_AbortController = useRef(null)
    const _fetch_sliced_AbortController = useRef(null)

    useEffect(() => {
        const fetchData = async (areaUuid) => {
            setIsModesLoading(true)

            console.log('Параметры изменились:');
            console.log('Дата начала:', startDate);
            console.log('Дата конца:', endDate);
            console.log('Выбранный таймфрейм:', selectedTimeframe);

            if(_fetch_modes_AbortController.current)  {
                _fetch_modes_AbortController.current.abort()
            }

            if(_fetch_sliced_AbortController.current)  {
                _fetch_sliced_AbortController.current.abort()
            }

            _fetch_modes_AbortController.current = new AbortController()

            try {
                const apiResponse = await dispatch(getDashboardOnlineDevices(areaUuid, startDate, endDate, selectedTimeframe, _fetch_modes_AbortController.current))
                if(!apiResponse.success) {
                    if(apiResponse.message !== 'cancel_request') {
                        return Swal.fire({text:apiResponse.message, icon: 'error'});
                    }
                }
                
                createDynamicColumns(apiResponse.payload.data['sliced_data']);

                const newData = transformApiData(apiResponse.payload.data['sliced_data']);
                setTransformedData(newData);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsModesLoading(false)
            }
        }

        const areaUuid = dataProps.areas[dataProps.areaIndex]?.id
        if(areaUuid != undefined)   {
            setTransformedData([])
            fetchData(areaUuid);
        }
    }, [startDate, endDate, selectedTimeframe, dataProps])

    const handleTimeframeChange = (timeframe) => {
        setSelectedTimeframe(timeframe);
        // Здесь вы можете добавить логику для обновления данных графика в соответствии с выбранным таймфреймом
    };

    function transformApiData(apiData) {
        const columnsMap = new Map();
        const timeMap = new Map();

        // Первый проход: сбор уникальных устройств и временных меток
        apiData.forEach(item => {
            columnsMap.set(item.key, true);
            
            if (!timeMap.has(item.mtime)) {
                timeMap.set(item.mtime, { mtime: item.mtime });
            }
            timeMap.get(item.mtime)[item.key] = item.value;
        });

        // Второй проход: заполнение отсутствующих значений
        const columns = Array.from(columnsMap.keys());
        const result = Array.from(timeMap.values()).map(row => {
            columns.forEach(col => {
                if (!(col in row)) row[col] = 0;
            });
            return row;
        });

        // Сортировка по времени
        return result.sort((a, b) => b.mtime - a.mtime);
    }

    const createDynamicColumns = (apiData) => {
        const uniqueKeys = Array.from(new Set(apiData.map(item => item.key)));
        
        const dynamicColumns = uniqueKeys.map(key => ({
            id: key,
            header: key,
            accessorFn: row => row[key] ?? 0,
            enableSorting: true,
            filterVariant: 'range',
            size: 150,
        }));

        setColumns([
          {
            id: 'time',
            header: 'Time',
            accessorFn: row => {
                if(selectedTimeframe == '5m' || selectedTimeframe == '30m' || selectedTimeframe == '1h') {
                    // UTC timestamp (в секундах) → миллисекунды
                    const utcMs = row.mtime * 1000;
                    // Добавляем +3 часа для Москвы
                    const mskMs = utcMs + (3 * 60 * 60 * 1000);
                    // Форматируем в локальную дату/время (или можно явно 'ru-RU')
                    return new Date(mskMs).toLocaleString('ru-RU');
                } else  {
                    return new Date(row.mtime * 1000).toLocaleString('ru-RU')
                }
                
            },
            //accessorFn: row => new Date(row.mtime * 1000).toLocaleString('ru-RU'),
            enableColumnFilter: false,
            //size: 200,
          },
          ...dynamicColumns,
        ]);
    };

    const table = useMaterialReactTable({
        columns,
        data: transformedData,
        enablePagination: false,
        enableRowNumbers: false,
        enableDensityToggle: false,
        columnFilterDisplayMode: 'popover',
        enableColumnFilterModes: false,
        enableFacetedValues: true,
        enableColumnResizing: true,
        layoutMode: 'grid',
        enableEditing: false,
        enableRowActions: false,
        enableStickyHeader: true,
        rowPinningDisplayMode: 'select-sticky',
        state: {
            isLoading: isModesLoading,
            showProgressBars: isModesLoading,
            density: 'compact',
        },
    })

    return (
        <Box >
            <Box sx={{ p: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
                    <Paper elevation={3} sx={{ 
                        p: 2, 
                        mb: 2, 
                        backgroundColor: '#f5f5f5',
                        borderRadius: 2,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }}>
                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                        }}>
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center',
                            }}>
                                <DateTimePicker
                                    label="Дата начала"
                                    value={startDate}
                                    onChange={(newValue) => setStartDate(newValue)}
                                    views={['year', 'month', 'day', 'hours', 'minutes']}
                                    format="dd.MM.yyyy HH:mm"
                                    ampm={false}
                                    timeZone="Europe/Moscow"
                                    sx={{ 
                                        backgroundColor: 'white',
                                        borderRadius: 1,
                                        '& .MuiInputBase-root': { height: 56 }
                                    }}
                                />
                                <Box sx={{ width: '50px' }} />
                                <DateTimePicker
                                    label="Дата конца"
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    views={['year', 'month', 'day', 'hours', 'minutes']}
                                    format="dd.MM.yyyy HH:mm"
                                    ampm={false}
                                    timeZone="Europe/Moscow"
                                    sx={{ 
                                        backgroundColor: 'white',
                                        borderRadius: 1,
                                        '& .MuiInputBase-root': { height: 56 }
                                    }}
                                />
                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', my: 0 }}>
                                <Divider sx={{ width: '25%' }} />
                            </Box>
                            <ButtonGroup size="secondary" aria-label="timeframe selection">
                                <Button 
                                    onClick={() => handleTimeframeChange('5m')}
                                    variant={selectedTimeframe === '5m' ? 'contained' : 'outlined'}>
                                    5m
                                </Button>
                                <Button 
                                    onClick={() => handleTimeframeChange('30m')}
                                    variant={selectedTimeframe === '30m' ? 'contained' : 'outlined'}>
                                    30m
                                </Button>
                                <Button 
                                    onClick={() => handleTimeframeChange('1h')}
                                    variant={selectedTimeframe === '1h' ? 'contained' : 'outlined'}>
                                    1h
                                </Button>
                                <Button 
                                    onClick={() => handleTimeframeChange('1d')}
                                    variant={selectedTimeframe === '1d' ? 'contained' : 'outlined'}>
                                    1d
                                </Button>
                                <Button 
                                    onClick={() => handleTimeframeChange('1M')}
                                    variant={selectedTimeframe === '1M' ? 'contained' : 'outlined'}>
                                    1M
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Paper>
                </LocalizationProvider>
            </Box>
            <Box sx={{ flex: 1, overflow: 'auto'}}>
                <MaterialReactTable table={table} />
            </Box>
        </Box>
    );
}

